import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Container,
  Form,
  Input,
  Row,
  Table,
} from "reactstrap";
import { getMethod } from "../api";
import Breadcrumbs from "../layout/breadcrumb";
import Loader from "../layout/loader/Loader";
import Layout from "./Layout";
import Pagination from "../utils/Pagination";
import DateRangeFormat from "../utils/DateRangeFormat";
import TableScroll from "../utils/TableScroll";
import { calculateProfit, calculateTotal, decodeData } from "../utils/Helper";
import { PROVIDER_API, USER_REPORT_API } from "../api/routes";
import moment from "moment";

const ReportUsers = () => {
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState("");
  const [startDate, setStartDate] = useState(moment().format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));
  const [searchPhone, setSearchPhone] = useState("");
  const [data, setData] = useState([]);
  const [providers, setProviders] = useState([]);
  const [totalPage, setTotalPage] = useState(0);
  const [from, setFrom] = useState(1);
  const [page, setPage] = useState(1);
  const [searchId, setSearchId] = useState("");
  const [refr, setRefr] = useState(true);

  useEffect(() => {
    const token = decodeData(localStorage.getItem("y_g_n_d_a"));
    if (!token) return;
    (async () => {
      setLoading(true);
      const res = await getMethod(
        `${USER_REPORT_API}?user_provider=user&user_id=${searchId}&start_date=${startDate}&end_date=${endDate}&page=${page}`,
        token.token
      );
      res && setLoading(false);
      if (res?.status === "success") {
        setData([]);
        setData(res?.data);
        res?.meta?.from && setFrom(res?.meta?.from);
        res?.meta?.last_page && setTotalPage(res?.meta?.last_page);
      }
    })();
  }, [refr, page]);

  useEffect(() => {
    (async () => {
      let res = await getMethod(`${PROVIDER_API}?dashboard=true`);
      res?.status === "success" && setProviders(res?.data);
    })();
  }, []);

  const searchSubmitHandler = () => {
    setRefr((prev) => !prev);
  };

  const statusHandler = (e) => {
    setStatus(e.target.value);
  };

  const searchHandler = (e) => {
    setSearchPhone(e.target.value);
  };
  const searchIdHandler = (e) => {
    setSearchId(e.target.value);
  };

  return (
    <>
      <Layout>
        <Breadcrumbs title="Users Report" />
        <Container fluid={true}>
        {loading && <Loader />}
          <Row>
            <Col sm="12">
              <Card>
                <CardHeader className="py-4">
                  <Col sm="12">
                    <Form>
                      <Row className="justify-content-end">
                        <Col md="4 px-1 mb-2">
                          <Input
                            className="form-control"
                            onChange={searchIdHandler}
                            type="number"
                            placeholder="Search ID"
                          />
                        </Col>
                        <Col md="4 px-1 mb-2">
                          <DateRangeFormat
                            setStartDate={setStartDate}
                            setEndDate={setEndDate}
                          />
                        </Col>
                        <Col md="4 px-1 mb-2">
                          <button
                            className="w-100 btn text-white btn-primary"
                            disabled={loading}
                            type="button"
                            onClick={searchSubmitHandler}
                          >
                            {loading ? "Loading..." : "Submit"}
                          </button>
                        </Col>
                      </Row>
                    </Form>
                  </Col>
                </CardHeader>
                <CardBody className="position-relative">
                  <TableScroll>
                    <Table className="table-border-vertical">
                      <thead>
                        <tr className="bg-dark">
                          <th className="text-center text-white" scope="col">
                            <b>No.</b>
                          </th>
                          <th className="text-center text-white" scope="col">
                            <b>Name</b>
                          </th>
                          <th className="text-center text-white" scope="col">
                            <b>Reg Phone</b>
                          </th>
                          <th className="text-center text-white" scope="col">
                            <b>User ID</b>
                          </th>
                          <th className="text-center text-white" scope="col">
                            <b>Bet Amount</b>
                          </th>
                          <th className="text-center text-white" scope="col">
                            <b>Payout</b>
                          </th>
                          <th className="text-center text-white" scope="col">
                            <b>Total Profit</b>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.length > 0 &&
                          data.map((el, i) => (
                            <tr key={i}>
                              <th className="text-center" scope="row">{`${
                                i + from
                              }.`}</th>
                              <td className="text-center">{el.name}</td>
                              <td className="text-center">{el.phone}</td>
                              <td className="text-center">{el.user_id}</td>
                              <td style={{ textAlign: "right" }}>
                                {el.bet
                                  ? el?.bet?.toLocaleString("en-us")
                                  : 0}
                              </td>
                              <td style={{ textAlign: "right" }}>
                                {el.payout
                                  ? el?.payout?.toLocaleString(
                                      "en-us"
                                    )
                                  : 0}
                              </td>
                              <td style={{ textAlign: "right" }}>
                                {(
                                  el.payout - el.bet
                                ).toLocaleString("en-us")}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                      <tfoot>
                        <tr className="bg-dark">
                          <td colSpan={4} className="text-center text-white">
                            Total
                          </td>
                          <td className="text-end text-white">
                            {calculateTotal(data, "bet")}
                          </td>
                          <td className="text-end text-white">
                            {calculateTotal(data, "payout")}
                          </td>
                          <td className="text-end text-white">
                            {calculateProfit(
                              data,
                              "payout",
                              "bet"
                            )}
                          </td>
                        </tr>
                      </tfoot>
                    </Table>
                  </TableScroll>
                </CardBody>
                <CardFooter className="d-flex justify-content-end">
                  <Pagination
                    setPage={setPage}
                    totalPage={totalPage}
                    setLoading={setLoading}
                  />
                </CardFooter>
              </Card>
            </Col>
          </Row>
        </Container>
      </Layout>
    </>
  );
};

export default ReportUsers;
